/**
 * Whether the signed-in user may open the Support Monitor.
 * Admins always may; everyone else needs the Settings grant.
 * The Support Monitor page and the user sidebar read this.
 */
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../lib/api-client';
import { queryKeys } from '../lib/query-keys';

import { useAuth } from './useAuth';

export function useSupportMonitorAccess(): { allowed: boolean; isLoading: boolean } {
  const { user, status } = useAuth();
  const query = useQuery({
    queryKey: queryKeys.supportMonitor.access(user?.id ?? ''),
    queryFn: () => apiRequest<{ allowed: boolean }>('/support-monitor/access'),
    enabled: status === 'authenticated' && !!user,
    staleTime: 60_000,
  });
  return {
    allowed: query.data?.allowed === true,
    isLoading: status === 'loading' || query.isLoading,
  };
}
